import { render, staticRenderFns } from "./goodsDialog.vue?vue&type=template&id=67a0f198&scoped=true&"
import script from "./goodsDialog.vue?vue&type=script&lang=js&"
export * from "./goodsDialog.vue?vue&type=script&lang=js&"
import style0 from "./goodsDialog.vue?vue&type=style&index=0&id=67a0f198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a0f198",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67a0f198')) {
      api.createRecord('67a0f198', component.options)
    } else {
      api.reload('67a0f198', component.options)
    }
    module.hot.accept("./goodsDialog.vue?vue&type=template&id=67a0f198&scoped=true&", function () {
      api.rerender('67a0f198', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iotScore/dialog/goodsDialog.vue"
export default component.exports